import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export const PUSH_STATE_KEY = ["dashboard", "push-state"] as const;

/**
 * GET /v1/stock/push-state — per-marketplace stock-push mode and
 * circuit-breaker pause state, for the Pipeline table's "Stock push" row.
 */
export function usePushState() {
  return useQuery({
    queryKey: PUSH_STATE_KEY,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/stock/push-state");
      if (error) throw error;
      return data.items;
    },
    refetchInterval: 60_000,
  });
}
